export const TOTAL_ORDER_LABEL = "Total Order";
export const TOTAL_QUANTITY_LABEL = "Total Quantity";
export const TOTAL_CUSTOMER_LABEL = "Total Customer";
export const TOTAL_PRODUCTS_LABEL = "Total Products";
export const TOP_CUSTOMER_LABEL = "Top Customers by Purchase Volume";
export const CUSTOMER_NAME = "Customer Name";
export const TOTAL_PURCHASES = "Total Purchases";
export const TOTAL_PURCHASES_ACCESS_KEY = "totalPurchase";
export const LAST_PURCHASE = "Last Purchase";
export const LAST_PURCHASE_ACCESS_KEY = "lastPurchaseDate";
export const TOTAL_AMOUNT = "Amount";
export const TOTAL_AMOUNT_ACCESS_KEY = "totalAmount";
export const CLEAR_LABEL = "Clear Filter";
